import type { RoleType } from '@/features/role/domain/enums/RoleType'

export class ChatEntity {
  createdAt?: string
  updatedAt?: string
  id?: string
  message?: string | null
  senderUserId?: string
  driverId?: number | null
  driverFullName?: string | null
  driverPhotoUrl?: string | null
  senderUserRoleType?: RoleType
  receiverUserId?: string | null
  receiverUserDisplayName?: string | null
  isRead?: boolean
  count?: number
  conversationCode?: string
  senderUserDisplayName?: string | null
}
